import { createAppPublicPathHelpers, readAppPublicPathFromEnv } from "@airange/shared/app-public-path";

const configuredPublicPath = typeof __AIRANGE_APP_PUBLIC_PATH__ === "string"
  ? __AIRANGE_APP_PUBLIC_PATH__
  : readAppPublicPathFromEnv();
const helpers = createAppPublicPathHelpers(configuredPublicPath);

export const browserBaseName = helpers.browserBaseName;
export const isAppLocalPathname = helpers.isAppLocalPathname;
export const toAppLocalPathname = helpers.toAppLocalPathname;
export const toAppLocalUrlPath = helpers.toAppLocalUrlPath;
export const toBrowserPath = helpers.toBrowserPath;
